import { render, staticRenderFns } from "./print-item-request.vue?vue&type=template&id=50a8a758"
import script from "./print-item-request.vue?vue&type=script&lang=js"
export * from "./print-item-request.vue?vue&type=script&lang=js"
import style0 from "./print-item-request.vue?vue&type=style&index=0&id=50a8a758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports